/* Durées en heures : affichage 7h06, saisie heures / minutes, arrondi au centième de la base. */

type Hours = number | string | null | undefined;

const toMinutes = (h: Hours): number => Math.round((parseFloat(String(h ?? 0)) || 0) * 60);

export function fmtHours(h: Hours): string {
  // 7.1 → '7h06', 7 → '7h', 0.5 → '30min' (arrondi à la minute).
  const total = toMinutes(h);
  const sign = total < 0 ? '-' : '';
  const hh = Math.floor(Math.abs(total) / 60);
  const mm = Math.abs(total) % 60;
  if (!mm) return `${sign}${hh}h`;
  if (!hh) return `${sign}${mm}min`;
  return `${sign}${hh}h${String(mm).padStart(2, '0')}`;
}

/* Heures décimales du brouillon ('7.1') ↔ champs heures / minutes ('7', '6'). */
export function splitHours(heures: Hours): { h: string; m: string } {
  if (heures === '' || heures == null) return { h: '', m: '' };
  const total = toMinutes(heures);
  return { h: String(Math.floor(total / 60)), m: String(total % 60) };
}

export function joinHours(h: string, m: string): string {
  if (h === '' && m === '') return '';
  return String((parseInt(h, 10) || 0) + (parseInt(m, 10) || 0) / 60);
}

export function clampMinutes(m: string): string {
  return m === '' ? '' : String(Math.min(59, Math.max(0, parseInt(m, 10) || 0)));
}

/* La base garde les heures au centième : 10 min = 0,1667h y devient 0,17h. Arrondir chaque ligne
   indépendamment peut faire dépasser le plafond (6 × 1h10 = 7,02h) : on arrondit donc de façon à
   ce que la somme arrondie reste égale à l'arrondi de la somme (plus forts restes). */
export function roundHoursToCents<T extends { heures: number }>(rows: T[]): T[] {
  const cents = rows.map((r) => r.heures * 100);
  const floors = cents.map((c) => Math.floor(c + 1e-9));
  let left = Math.round(cents.reduce((s, c) => s + c, 0)) - floors.reduce((s, c) => s + c, 0);
  const order = cents.map((c, i) => [c - floors[i], i]).sort((x, y) => y[0] - x[0]);
  for (const [, i] of order) {
    if (left <= 0) break;
    floors[i] += 1;
    left -= 1;
  }
  return rows.map((r, i) => ({ ...r, heures: floors[i] / 100 }));
}
